(function() { window.GUID_f77d4dba_6a34_4799_8794_c24133b55006 = { getGuid: function() { return "f77d4dba-6a34-4799-8794-c24133b55006"; } }; })();
var CompuSport;
(function (CompuSport) {
    class CSRequestAnimationFrame {
        Request(callback) {
            let me = this;
            if (me.inProcess) {
                return;
            }
            me.inProcess = true;
            requestAnimationFrame(function () {
                callback.call(me);
                me.inProcess = false;
            });
        }
    }
    CompuSport.CSRequestAnimationFrame = CSRequestAnimationFrame;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=CSRequestAnimationFrame.js.map
